<template>
  <div v-if="animateRocket" class="rocket-container launch">
    <img class="rocket" :src="rocket" alt="rocket" />
  </div>
  <div v-else class="rocket-container" />
</template>

<script>
export default {
  data() {
    return {
      rocket: require('@/assets/rev/Rocket.svg'),
      animateRocket: false,
    }
  },
  methods: {
    launchRocket() {
      this.animateRocket = true
      setTimeout(() => {
        this.animateRocket = false
      }, 1500)
    },
  },
}
</script>

<style lang="scss">
.rocket-container {
  z-index: 1000;
  position: fixed;
  bottom: 0;
  left: 25%;
  transform: translateX(-50%);
}

.launch {
  transition: transform 1.5s linear;
  transform: translate(-50%, -100vh) translateX(70vw);
}

.rocket {
  width: 140px;
  transition: opacity 0.5s ease-in-out;
}
</style>
